import { HelpIcon } from './HelpIcon';

export function NumberField({ id, label, value, onChange, error, helpText, placeholder, required, readOnly, min, max, unit, currency, decimalPlaces }) {
  const displayUnit = currency || unit;
  const hasPfx = displayUnit && displayUnit.length <= 3;
  const step = decimalPlaces !== undefined ? Math.pow(10, -decimalPlaces).toString() : 'any';
  return (
    <div className="fw">
      <label className="fl" htmlFor={`field-${id}`}>
        {label}
        {required && <span className="req"> *</span>}
        {helpText && <HelpIcon text={helpText} id={id} />}
      </label>
      <div className="fi-wrap">
        {hasPfx && <span className="fi-pfx">{displayUnit}</span>}
        <input id={`field-${id}`} type="number"
          value={value === '' ? '' : value}
          onChange={e => onChange(e.target.value === '' ? '' : Number(e.target.value))}
          placeholder={placeholder} readOnly={readOnly} min={min} max={max} step={step}
          aria-invalid={!!error}
          className={`field-input${hasPfx ? ' field-input-pfx' : ''}${error ? ' field-error-border' : ''}${readOnly ? ' field-readonly' : ''}`}
        />
        {displayUnit && !hasPfx && <span className="fi-sfx">{displayUnit}</span>}
      </div>
      {error && <span className="ferr" role="alert">{error}</span>}
    </div>
  );
}
